/**
 * The brand mark shown in the top bar and footers (logo decision 20.10.2026).
 *
 * One thought bubble, many thinkers: the philosopher or the woman, picked at random once per page
 * load so every mark on the same visit agrees. Navigating inside the app keeps the choice; a reload
 * may change it. The home-screen icon stays the philosopher (static file in index.html).
 *
 * Below 32 px the figures do not read, so anything that small shows only the empty bubble with a
 * thicker line (decision 20.10.2026); the browser tab icon is that bubble too.
 */
const BRAND_MARKS = ['/brand/aot-philosopher.svg', '/brand/aot-woman.svg'] as const;

export const BRAND_MARK_SRC: string = BRAND_MARKS[Math.floor(Math.random() * BRAND_MARKS.length)];

export const BRAND_MARK_SMALL_SRC = '/brand/aot-bubble-small.svg';

/**
 * Thinking Dino, the helper character (logo decision 20.10.2026): the "being made" screen and the
 * host help chat. Same size rule as the marks: never at 32 px or below. /thinking-dino.png is the
 * old green raptor, kept only for rollback.
 */
export const HELPER_MARK_SRC = '/brand/aot-thinking-dino.svg';
